module.exports = __webpack_public_path__ + "static/media/BDSPROSTHODONTICS.dfa55fe0.pdf";